export default "__VITE_ASSET__3a607014__"